module.exports = {
      id: "icon-login-usage",
      viewBox: "0 0 10.66 10.66",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#icon-login",
      toString: function () {
        return this.url;
      }
    }